<template>
  <v-dialog v-model="showInviteLinkDialog" max-width="500">
    <v-card>
      <h4 class="title mx-5 my-2 pt-5">Invitation Link</h4>
      <div class="pa-5 pt-5 d-flex align-center" ref="copyText">
        <v-text-field
          v-model="url"
          label="Invitation Link"
          type="text"
          dense
          outlined
          :loading="loading"
          hide-details
        ></v-text-field>
        <v-btn text small class="ml-2" @click="copyUrl">
          <v-icon small class="mr-2">fa fa-clone</v-icon>
          Copy
        </v-btn>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red lighten-1" text @click="showInviteLinkDialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'InviteLinkDialog',
  data: () => ({
    url: '',
    loading: false,
  }),
  props: {
    value: Boolean,
  },

  computed: {
    showInviteLinkDialog: {
      get() {
        if (this.value) {
          this.renderUrl();
        }

        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.renderUrl();
  },
  methods: {
    renderUrl() {
      this.loading = true;
      this.$http
        .get('central/invite-link', {
          params: {
            company_id: this.$auth.user().dealer.central_id,
          },
        })
        .then(({ data }) => {
          this.loading = false;
          this.url = data;
        });
    },
    copyUrl() {
      let copyText = this.$refs.copyText;
      this.$copyText(this.url, copyText);
    },
  },
};
</script>
